<div
	[ngClass]="{
		'grid grid-cols-2 gap-2 items-center': labelPosition === 'left',
	}"
	class="relative"
>
	<p *ngIf="labelPosition === 'left'" class="flex-1">Counsel credit</p>
	<div class="flex gap-2 items-center">
		<app-input
			[label]="labelPosition === 'top' ? 'Counsel credit' : ''"
			type="cents"
			[ngModel]="counselCredit || 0"
			(debounce)="setCounselCredit($event)"
			[testHook]="testHooks.Input"
		></app-input>
		<app-icon
			[class]="
				'w-5 cursor-pointer ' +
				counselPillData?.iconClass +
				(labelPosition === 'top' ? ' mt-5' : '')
			"
			[icon]="counselPillData?.icon"
			(click)="togglePill('counsel')"
			[testHook]="testHooks.TogglePillIcon"
		></app-icon>
		<div
			*ngIf="displayPill === 'counsel'"
			class="gap-4 text-sm absolute -bottom-4 -right-24 bg-white border py-1 px-2 rounded-xl z-50 flex items-start justify-between"
		>
			<div>
				<app-icon
					[icon]="counselPillData?.icon"
					[class]="counselPillData?.iconClass"
				></app-icon>
				<span class="ml-3">{{ counselPillData?.text }}</span>
			</div>
			<app-icon
				class="cursor-pointer"
				[icon]="ICON.CLOSE"
				(click)="togglePill('none')"
				[testHook]="testHooks.TogglePillIcon1"
			></app-icon>
		</div>
	</div>
</div>
